import { render } from "./ModulesPage.vue?vue&type=template&id=5ec59e91"
import script from "./ModulesPage.vue?vue&type=script&lang=js"
export * from "./ModulesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__